import React, { useState } from "react";
import { Space, DatePicker, Select, Input } from "antd";

const WeightDisputeByMerchantFilters = ({ filters, onFiltersChange }) => {
  const [searchField, setSearchField] = useState("userEmail");
  const searchBy = (
    <Select
      defaultValue="userEmail"
      className="select-before"
      onChange={(value) => setSearchField(value)}
    >
      <Select.Option value="userEmail">User Email</Select.Option>
    </Select>
  );

  return (
    <Space size="large" wrap>
      <div>
        <DatePicker.RangePicker
          value={[filters.startDate, filters.endDate]}
          onChange={(dates) =>
            dates
              ? onFiltersChange({
                  ...filters,
                  startDate: dates[0],
                  endDate: dates[1],
                })
              : onFiltersChange({
                  ...filters,
                  startDate: undefined,
                  endDate: undefined,
                })
          }
        />
      </div>

      <div>
        <Input.Search
          addonBefore={searchBy}
          placeholder="Search"
          onSearch={(term) =>
            onFiltersChange({ ...filters, search: term, searchField })
          }
        />
      </div>

      <div>
        Sort By :{` `}
        <Select
          placeholder="Total Price Diff"
          style={{ width: 200 }}
          allowClear
          onChange={(value) =>
            onFiltersChange({
              ...filters,
              sort: value,
            })
          }
        >
          <Select.Option value="totalPriceDiff">Total Price Diff (Highest)</Select.Option>
          <Select.Option value="currentCredits">Current Credits (Lowest)</Select.Option>
          <Select.Option value="lastLoginAtDesc">Last Login At (Latest)</Select.Option>
          <Select.Option value="lastLoginAtAsc">Last Login At (Oldest)</Select.Option>
        </Select>
      </div>
    </Space>
  );
};

export default WeightDisputeByMerchantFilters;
